import styled from 'styled-components';

import Pie, { defaultColorPalette } from 'core/chart/pie';
import { body1, colors, fontWeights, spacing } from 'ui/theme';

import { AudienceCount } from '../../../types';
import { useFormatAudienceName } from '../../../hooks';
import { PieChartSkeleton } from './PieChartSkeleton';

const options = {
  chart: {
    style: {
      fontFamily: 'Sofia Pro',
    },
    height: 256,
  },
  exporting: { enabled: false },
  tooltip: { enabled: false },
  plotOptions: {
    pie: {
      borderColor: colors.white,
      borderWidth: spacing.single,
      size: '70%',
      innerSize: '50%',
      dataLabels: {
        enabled: true,
        connectorShape: 'straight',
        x: -3,
        distance: 20,
        format: `<span style="color:${colors.textSecondary};font-size:14px;">{point.name}  </span>\
            <br/><span style="font-size:20px;">{point.percentage:.2f}%</span>`,
        style: {
          fontWeight: fontWeights.regular,
        },
      },
      colors: defaultColorPalette,
    },
  },
};

const Wrapper = styled.div<{ $hasChart: boolean }>`
  ${body1};
  border-bottom: ${({ $hasChart }) => $hasChart && `${spacing.single} solid #bdbdbd`};
  padding-bottom: ${spacing.plusQuarter};
  margin: 0 -${spacing.base} 0 -${spacing.plusHalf};
`;

export const PIE_CHART_DATA_TEST = 'insight-pie-chart';

export type PieChartProps = {
  audienceCounts: AudienceCount[];
  hasChart?: boolean;
  isLoading?: boolean;
  isEnabled?: boolean;
};

export const PieChart = ({
  audienceCounts,
  hasChart = false,
  isLoading = false,
  isEnabled = false,
}: PieChartProps) => {
  const formatName = useFormatAudienceName();

  if (!isEnabled) return null;
  if (isLoading) return <PieChartSkeleton />;

  return (
    <Wrapper data-test={PIE_CHART_DATA_TEST} $hasChart={hasChart}>
      <Pie
        data={{ data: audienceCounts.map(({ name, count: y }) => ({ name: formatName(name), y })) }}
        options={options}
      />
    </Wrapper>
  );
};
